import { render, staticRenderFns } from "./PendenciesApproved.vue?vue&type=template&id=1f005f64&scoped=true"
import script from "./PendenciesApproved.vue?vue&type=script&lang=js"
export * from "./PendenciesApproved.vue?vue&type=script&lang=js"
import style0 from "./PendenciesApproved.vue?vue&type=style&index=0&id=1f005f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f005f64",
  null
  
)

export default component.exports